import { isCustomClothingCategory } from "../../../constants/categories";

export const sortProductCategories = (
  categories: string[],
  skuByCategory: Record<string, any[]>
) => {
  const nonCustomCategories = categories.filter(
    (category) => !isCustomClothingCategory(category)
  );

  const clothingCategoryCounts = {
    "Custom Hoodies": skuByCategory["Custom Hoodies"]?.length || 0,
    "Custom T-Shirts": skuByCategory["Custom T-Shirts"]?.length || 0,
    "Custom Racerbacks": skuByCategory["Custom Racerbacks"]?.length || 0,
  };

  const clothingCategories = [
    "Custom Hoodies",
    "Custom T-Shirts",
    "Custom Racerbacks",
  ].filter((cat) => nonCustomCategories.includes(cat));

  const otherCategories = nonCustomCategories
    .filter((cat) => !clothingCategories.includes(cat))
    .sort((a, b) => a.localeCompare(b));

  return {
    sortedCategories: [...clothingCategories, ...otherCategories],
    showClothingDropdown: Object.values(clothingCategoryCounts).some(
      (count) => count > 0
    ),
    clothingCategoryCounts,
  };
};
